import ResizableContainer from "./ResizableContainer";

export default class AnimatedPopup extends ResizableContainer {
	protected _overlay: Phaser.GameObjects.Sprite;
	protected _popupGroup: Phaser.GameObjects.Container;
	protected _bodyText: Phaser.GameObjects.Text[] = [];
	protected _headerBG: Phaser.GameObjects.Image;
	protected _headerText: Phaser.GameObjects.Text | Phaser.GameObjects.Image;
	protected _buttons: Phaser.GameObjects.Image[] = [];
	protected _buttonBackgrounds: Phaser.GameObjects.Image[] = [];
	protected _buttonsText: Phaser.GameObjects.Text[] = [];
	protected _bottomY: number;

	intro(): void {
		const y = this._popupGroup.y;
		this.scene.alignTo.BottomCenter(this._popupGroup, this.scene.viewport);
		this._bottomY = this._popupGroup.y;

		this.scene.soundManager.play("popupEnter");

		this.scene.tweens.add({
			targets: this._overlay,
			alpha: { from: 0, to: 0.5 },
			duration: 150,
		});
		this._overlay.alpha = 0;

		this.scene.tweens.add({
			targets: this._popupGroup,
			y: y,
			duration: 350,
			ease: Phaser.Math.Easing.Back.Out,
		});

		this.scene.add.tween({
			targets: this._popupGroup,
			alpha: 1,
			duration: 350,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
		this._popupGroup.alpha = 0;

		const headers = [];
		if (this._headerBG) {
			this._headerBG.setScale(0);
			headers.push(this._headerBG);
		}
		if (this._headerText) {
			this._headerText.setScale(0);
			headers.push(this._headerText);
		}
		const headerTimeline = this.scene.tweens.createTimeline();
		headerTimeline.add({
			targets: headers,
			delay: 250,
			scale: { from: 0, to: 1.1 },
			duration: 250,
			ease: Phaser.Math.Easing.Quadratic.In,
		});
		headerTimeline.add({
			targets: headers,
			scale: { from: 1.1, to: 1 },
			duration: 100,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
		headerTimeline.play();

		if (this._buttons.length > 0) this.animateButtons(this._buttons);
		if (this._buttonsText.length > 0) this.animateButtons(this._buttonsText);
		if (this._buttonBackgrounds.length > 0) this.animateButtonBackgrounds(this._buttonBackgrounds);

		if (this._bodyText.length > 0) {
			this.scene.add.tween({
				targets: this._bodyText,
				delay: 600,
				alpha: 1,
				duration: 350,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
			for (const t of this._bodyText) t.alpha = 0;
		}
	}

	animateButtons(items: Phaser.GameObjects.Image[] | Phaser.GameObjects.Text[]): void {
		const buttonTimeline = this.scene.tweens.createTimeline();
		buttonTimeline.add({
			targets: items,
			delay: 300,
			scale: { from: 0, to: 1.1 },
			duration: 250,
			ease: Phaser.Math.Easing.Quadratic.In,
		});
		buttonTimeline.add({
			targets: items,
			scale: { from: 1.1, to: 1 },
			duration: 100,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
		buttonTimeline.play();

		this.scene.add.tween({
			targets: items,
			delay: 300,
			alpha: { from: 0, to: 1 },
			duration: 350,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});
		for (const c of items) {
			c.alpha = 0;
			c.setScale(0);
		}
	}

	// For when buttons a preselected. These should fade in after buttons
	animateButtonBackgrounds(items: Phaser.GameObjects.Image[]): void {
		this.scene.add.tween({
			targets: items,
			delay: 550,
			alpha: { from: 0, to: 1 },
			duration: 100,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});

		for (const c of items) {
			c.alpha = 0;
		}
	}

	outro(): void {
		this.scene.soundManager.play("popupExit");

		this.scene.tweens.add({
			targets: this._overlay,
			alpha: 0,
			duration: 150,
			delay: 100,
		});

		const moveTween = this.scene.tweens.add({
			targets: this._popupGroup,
			y: this._bottomY,
			duration: 250,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});

		moveTween.on(Phaser.Tweens.Events.TWEEN_COMPLETE, () => {
			this.destroy();
		});
	}

	destroy(): void {
		if (this._overlay) this._overlay.destroy();
		if (this._popupGroup) this._popupGroup.destroy();

		this._overlay = null;
		this._popupGroup = null;

		super.destroy();
	}
}
